import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { EsMerchantsPayoutFiles } from "ui/organizms/QueryBuilder";

const EsMerchantPayoutFilesScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Query Builder | Es-Merchant Payout Files'
    >
        <EsMerchantsPayoutFiles />
    </Screen>
);

export default memo(EsMerchantPayoutFilesScreen);
